import React from 'react';
import { useSelector } from 'react-redux';
import GameCard from '@/pages/games/game-card/GameCard';
import GamesSkeletonLoader from '@/components/shared/skeleton-loader/GamesSkeletonLoader';
import { selectGamesByIds, selectGamesLoading } from '@/store/games/selectors';

function PromotionGames({ gameIds }: { gameIds: number[] }) {
  const games = useSelector(selectGamesByIds(gameIds ?? []));
  const gamesLoading = useSelector(selectGamesLoading);

  // gameIds can be undefined at runtime during deploy skew (promotions served by
  // an older BFF have no games fields), so guard beyond what the type promises.
  if (!gameIds || gameIds.length === 0) {
    return null;
  }

  if (gamesLoading) {
    return (
      <div className="my-8">
        <GamesSkeletonLoader />
      </div>
    );
  }

  if (games.length === 0) {
    return null;
  }

  return (
    <div className="my-8 grid grid-cols-2 md:grid-cols-4 gap-x-4 gap-y-8">
      {games.map(game => (
        <GameCard key={`${game.slug}-${game.gameId}`} game={game} category="promotions" />
      ))}
    </div>
  );
}

export default PromotionGames;
